import { rem } from 'polished';
import styled from 'styled-components';

import { Header, Paragraph } from '@vimeo/iris/typography';

export const TopBar = styled.div<{ isSearching: boolean | undefined }>`
  padding-top: ${rem(70)};
  margin-bottom: ${({ isSearching }) => (isSearching ? '0' : rem(50))};
  ${({ isSearching }) => isSearching && 'display: none;'};
`;

export const CustomLogo = styled.div`
  width: 100px;
  position: relative;
  overflow: hidden;
  max-height: 200px;
  margin-bottom: ${rem(20)};

  img {
    width: 100%;
    height: auto;
  }
`;

export const MegaHeader = styled(Header).attrs({ size: 'plusUltra' })`
  max-width: 64rem;
`;

export const AlbumDescription = styled(Paragraph).attrs({ size: '1' })`
  @media only screen and (min-width: 767px) {
    font-size: ${rem(20)};
  }
`;
